import type {Prompt} from '@cp/model';
import {useCallback, useState} from 'react';
import {promptsGetPdfSystem} from '../../api/callable/prompts';

export function useGetPdfSystemPrompt() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const getPdfSystemPrompt = useCallback(async (additionalInfo?: string): Promise<Prompt> => {
    setLoading(true);
    setError(undefined);
    try {
      return await promptsGetPdfSystem({additionalInfo: additionalInfo || undefined});
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getPdfSystemPrompt,
    loading,
    error,
  };
}
